import { planTypes } from "@/common/constants";
import store from "@/store";
import { UnconfigCallingPlanCategory } from '@/plans/ZOOM_PHONE/helper/constants.js';

export const PBX_SUB_TYPES = {
  UNLIMITED: 'UC',
  METERED: 'MC',
  TOLLFREE: 'TF',
  PHONE_NUMBER: 'PN',
  BASE: 'BASE',
  FEATURE: 'FT',
  UNLIMITED_ADDON: 'UNLIMITED_ADDON',
  TOLLFREE_TP: 'TP', // tollfree sub type exist TP or TF
};
export const UNLIMITED_ADDON_CATEGORY_CODES = ['ZPI'];

export const isZoomPhone = (planType = "") => {
  const [type] = planType.split('$');
  return type === planTypes.ZOOM_PHONE;
}

export const computedPbxPlans = plans => plans.filter(item => {
  const [type] = item.type.split('$');
  return type === planTypes.ZOOM_PHONE
});
export const computedPbxBasePlans = plans => computedPbxPlans(plans).filter(item => item.sub_type === PBX_SUB_TYPES.BASE);
export const computedPbxNonBasePlans = plans => computedPbxPlans(plans).filter(item => item.sub_type !== PBX_SUB_TYPES.BASE);
export const computedPbxCallingPlans = plans => computedPbxPlans(plans).filter(item => [PBX_SUB_TYPES.METERED, PBX_SUB_TYPES.UNLIMITED].includes(item.sub_type));
export const computedPbxTollFreePlans = plans => computedPbxPlans(plans).filter(item => item.sub_type === PBX_SUB_TYPES.TOLLFREE);
export const computedPbxPhoneNumberPlans = plans => computedPbxPlans(plans).filter(item => item.sub_type === PBX_SUB_TYPES.PHONE_NUMBER);
export const computedPbxAddonPlans = plans => computedPbxPlans(plans).filter(item => item.sub_type === PBX_SUB_TYPES.UNLIMITED_ADDON);
export const computedPbxMeteredPlans = plans => computedPbxPlans(plans).filter(item => item.sub_type === PBX_SUB_TYPES.METERED);
export const computedPbxUnlimitedPlans = plans => computedPbxPlans(plans).filter(item => item.sub_type === PBX_SUB_TYPES.UNLIMITED);
export const computedPbxFeaturePlans = plans => computedPbxPlans(plans).filter(item => item.sub_type === PBX_SUB_TYPES.FEATURE);
export const computedPbxAdditionalPlans = plans => computedPbxPlans(plans).filter(item => item.sub_type === PBX_SUB_TYPES.PHONE_NUMBER || item.sub_type === PBX_SUB_TYPES.TOLLFREE);
// including calling plans of: pbx + zoom bundle + zoom united
export const computedCallingPlans = plans => [
  ...plans.filter(x => x.type === planTypes.ZOOM_ONE_BUNDLE || x.type === planTypes.ZOOM_UNITED || x.type === planTypes.ZONE_PRO_PLUS),
  ...computedPbxCallingPlans(plans),
];

// unlimited calling plans of: pbx + zoom bundle + zoom united
export const computedUnlimitedCallingPlans = (plans = []) => [
  ...plans.filter(x => x.type === planTypes.ZOOM_ONE_BUNDLE || x.type === planTypes.ZOOM_UNITED || x.type === planTypes.ZONE_PRO_PLUS),
  ...computedPbxUnlimitedPlans(plans),
];

const isActiveBundlePlan = (plan) => {
  return [planTypes.ZOOM_ONE_BUNDLE, planTypes.ZOOM_UNITED].includes(plan.type) && !plan.cartInfo?.cancelled;
}
export const computedActiveCallingPlans = (plans = []) => computedCallingPlans(plans).filter(
  item => !store.getters?.plancodeMapSubscriptionDisabled[item.plan_code] || isActiveBundlePlan(item)
);
export const computedActiveUnlimitedCallingPlans = (plans = []) => computedUnlimitedCallingPlans(plans).filter(
  item => !store.getters?.plancodeMapSubscriptionDisabled[item.plan_code] || isActiveBundlePlan(item)
);

export const computedPbxUnconfigCallingPlans = plans => computedPbxPlans(plans).filter(item => UnconfigCallingPlanCategory.includes(item?.category));
